import { simpleSet } from '@r/reducers/utils';

const toggleCalculationModeEditProjectModal = simpleSet as
  redux.reducers.calculationMode.modals.editProject;

export const editProject = toggleCalculationModeEditProjectModal(
  'TOGGLE_CALCULATION_MODE_EDIT_PROJECT_MODAL',
  false
);
